import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success'
import FeedbackError from '../../../components/atoms/feedbacks/feedback-error'
import PageHeadline from '../../../components/molecules/headlines/PageHeadline'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    PageHeadline
  },
  data() {
    return {
      gift_code: '',
      showableSuccessFeedback: false,
      successMessage: '',
      showableErrorFeedback: false,
      errorMessage: '',
      showableAccordion: false
    }
  },
  mounted() {
    // エラーフィードバックメッセージの表示
    const errorMessage = document.querySelector('.error_message')
    if (errorMessage) {
      this.showableErrorFeedback = true
      this.errorMessage = 'ギフトコードにエラーがあります'
    }

    // エラーの際に input field にギフトコードを表示する処理
    const giftCodeHtml = document.querySelector(
      '#gift_code_mypage_serial_form_gift_code'
    ).outerHTML
    const giftCode = giftCodeHtml.match(/value="(.*?)"/)
    if (giftCode) this.gift_code = giftCode[1]

    // 登録が成功した場合のサクセスフィードバックメッセージの表示
    const feedbackMessage = document.querySelector('#flash_message').value
    if (feedbackMessage) {
      this.showableSuccessFeedback = true
      this.successMessage = feedbackMessage
    }
  },
  computed: {
    isInputted() {
      return this.gift_code.length !== 0
    }
  },
  methods: {
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    showAccordion() {
      this.showableAccordion = !this.showableAccordion
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    }
  }
}
